import React, { useEffect } from "react";

function UploadInput({ fileValue, setFilePopUp, setNumberOfWords, numberOfWords, errorThree, setErrorThree }) {
  // fileValue.reduce((prev, next) => prev + next.noOfWords, 0)

  const handleNumberOfWords = (e) => {
    setNumberOfWords(e.target.value);
    setErrorThree(false);

  };
  return (
    <div className="flex flex-wrap lg:flex-nowrap w-full 2xl:w-11/12 lg:w-11/12 justify-center lg:ml-2 2xl:ml-11">
      <label className="flex flex-col items-center justify-start w-full font-opensans 2xl:ml-[-43px]">
        <span className="text-[18px] w-full text-left 2xl:ml-9 font-opensans">Word Count/Upload Your File</span>
        <div className="w-full flex justify-start items-center font-arial h-[50px]  min-w-[280px] lg:w-[325px] bg-white pl-4 rounded-xl border border-[#CCCCCC] border-solid text-[#777777] mb-2">
          <p className="cursor-pointer w-8/12  font-arial">
            {fileValue?.length ? (
              <span className="inline-block  text-lg w-6/12 text-black">{fileValue?.reduce((prev, next) => prev + next.noOfWords, 0)}</span>
            ) : (
              <span className="inline-block  text-lg w-full text-black" style="width: 90%;border-right: 1px solid #e2e2e2;">
                <input value={numberOfWords !== 0 ? numberOfWords : null} className="w-full outline-none" placeholder="No of Words" onChange={handleNumberOfWords} />
              </span>
            )}

            <span className={`${fileValue?.length !== 0 ? "text-black" : "w-0"}`}>{fileValue?.length ? `| ${fileValue?.length} ${fileValue?.length === 1 ? "File" : "Files"}` : null}</span>
          </p>
          {localStorage.getItem("quote_id") &&
          <p className="bg-quotetext-500 text-white font-opensans text-[13px] px-4 mr-2 rounded-lg font-bold py-1 whitespace-nowrap cursor-pointer" onClick={() => setFilePopUp(true)}>
            UPLOAD FILE
          </p>
          }
          {!localStorage.getItem("quote_id") &&
          <p className="bg-quotetext-500 text-white font-opensans text-[13px] px-4 mr-2 rounded-lg font-bold py-1 whitespace-nowrap  bg-opacity-30 cursor-not-allowed">
            UPLOAD FILE
          </p>
          }
        </div>
        {errorThree && <span className="text-red block mr-auto 2xl:pl-5">This field is required.</span>}{" "}
      </label>
    </div>
  );
}

export default UploadInput;
